<div class="BookAptPanel">
    <div class="msLeft">
    </div>
    <div class="msRight">
        <dx-button #btnBookAptCtl2
            style="padding:10px; margin:10px 15px; flex:100%; background-color: var(--main_button-color); color:var(--main_button-text-color); font-size: 20px; font-weight: bold;"
            text="Book Appointment" title="Book Appointment" (click)="btnBookAppointment($event)"
            [disabled]="disabled">
        </dx-button>
    </div>
</div>